<script setup lang="tsx">
import { getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: getCSSVar("--xg-blue")
  }
);

const style = { backgroundColor: props.color };
</script>

<template>
  <div class="loading-6">
    <div :style="style"></div>
    <div :style="style"></div>
    <div :style="style"></div>
  </div>
</template>

<style scoped>
.loading-6 {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}

.loading-6 > div {
  border-radius: 100%;
}

.loading-6 > div:nth-child(2) {
  animation-delay: -0.4s;
}

.loading-6 > div:nth-child(3) {
  animation-delay: -0.2s;
}

.loading-6 > div {
  position: absolute;
  left: 20%;
  top: 20%;
  width: 60%;
  aspect-ratio: 1 / 1;
  opacity: 0;
  margin: 0;
  animation: loading-6 1s 0s linear infinite;
}
@keyframes loading-6 {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  5% {
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 0;
  }
}
</style>
